import { useTranslation } from 'react-i18next';

import type { BingoCoinType } from '../../stores/bingo/types';

import styles from './LobbyPassBanner.module.scss';

interface BannerResultProps {
  titleText: string;
  bingoResultToShow: { coinType: BingoCoinType; totalUserReward: number; gameId: string };
}

export const BannerResult = ({ titleText }: BannerResultProps) => {
  const { t } = useTranslation();

  return (
    <>
      <span className={styles.bingoType}>{titleText}</span>
      <span className={styles.titleText}>{t('prime.latestBingoResult.youWon')}</span>
    </>
  );
};
